import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@/shared/api/apiClient'
import {
  OrganizationAddress,
  OrganizationContact,
  OrganizationDetails
} from '@/features/organization/api/OrganizationModel'
import { USER_SESSION_QUERY_KEY } from '@/features/auth/hooks/useAuth'

export const useDoesOrganizationRequiresLocalAddress = (
  placeOfRegistration: string | undefined | null
) => {
  return placeOfRegistration ? placeOfRegistration === 'cn' : false
}

export const useUpdateOrganization = (organizationId: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (
      payload: Partial<OrganizationAddress & OrganizationContact & OrganizationDetails>
    ) => {
      const res = await apiClient.patch(`/v1/organizations/${organizationId}`, payload)
      return res.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [USER_SESSION_QUERY_KEY] })
    }
  })
}

export const useSaveOrganizationMandatoryInfo = (organizationId: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (payload: OrganizationDetails) => {
      const response = await apiClient.post<{
        id: string
      }>(`/v1/organizations/${organizationId}/info`, payload)
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [USER_SESSION_QUERY_KEY] })
    }
  })
}
